/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unlimiteddrafts1Inputs */

const en_unlimiteddrafts1 = /** @type {(inputs: Unlimiteddrafts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited drafts`)
};

const de_unlimiteddrafts1 = /** @type {(inputs: Unlimiteddrafts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenzt Entwürfe`)
};

/**
* | output |
* | --- |
* | "Unlimited drafts" |
*
* @param {Unlimiteddrafts1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const unlimiteddrafts1 = /** @type {((inputs?: Unlimiteddrafts1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unlimiteddrafts1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unlimiteddrafts1(inputs)
	return de_unlimiteddrafts1(inputs)
});
export { unlimiteddrafts1 as "unlimitedDrafts" }